import { useContext } from "react";
import { UserContext } from "../UserContext";

function Footer() {
  const userdata = useContext(UserContext);
  const currentYear = new Date().getFullYear();
  
  // Parse user data safely
  let user;
  try {
    user = JSON.parse(userdata);
  } catch (error) {
    user = null;
  }

  return (
    <footer className="main-footer bg-light border-top">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="footer-info">
              <strong className="text-primary">
                <span className="platform-name">ለAmbulance</span>
              </strong>
              <div className="copyright-text text-muted mt-1">
                © {currentYear} ለAmbulance. All rights reserved.
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="footer-version text-right d-none d-sm-block">
              <small className="text-muted">
                <strong>Version</strong> 3.2.0
              </small>
            </div>
          </div>
        </div>
        
        <div className="row mt-2">
          <div className="col-12">
            <div className="footer-links text-center">
              <small className="text-muted">
                Emergency Medical Services Platform
              </small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
